import type { FaireProductEntity } from "../../entity_types/product";

export const p_zm9gnr36ev: FaireProductEntity = {
  token: "p_zm9gnr36ev",
  type: "product",
  name: "Squirrels Brown",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/523cda13e9cde70234f717be2544db4ced3ea1c7ef09e3b3e2f138df77af2b7f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b119162a0f30f9d506aaf1f8a7867d54b03b2cffeb4ad4abd873d385cf4e2d2c.jpeg",
    "https://cdn.faire.com/fastly/a72f45c7ecbfb79ef0ec6ffdffc75ff7beef75af35d158c45530194003c66153.jpeg"
  ],
  priceDollars: 9.5,
  description: "Dog Towel \n\n30\" x 30\" \n\n\n\nOur signature towel. Gone to the dogs.\n\nThe Geometry products you love, now perfectly designed for your pup! Our Dog Towels are lightweight, highly absorbent and quick drying, so you can spend less time washing and more time cuddling your furry friends. \n\nPet Responsibly. \n\nWith its natural softness and ultra-absorbent weave, our Paw Towels are guaranteed to be your new favorite companion (besides your doggy, of course!) The best part? They’re also friends to the environment. Our towels are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. \n\n\n",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:00.821Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
